import React, { Fragment, useState } from "react";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import { NavLink } from "react-router-dom";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import EditUserOpenIssues from "./InsideAllPageComponent/EditUserOpenIssues";
// import SuperAdminCall from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
// import SuperAdminSMS from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
// import SuperAdminNotification from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
// import SuperAdminFlag from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
// import SuperAdminBlockUser from "../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
// import { SuperAdminVendorViewDetailsPopup } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup";
// import ApprovedModelPopup from "../ApprovedModelPopup";
// import OnHoldPendingModel from "../OnHoldPendingModel";
// import isEmpty from "../../../../../../store/validation/is-Empty";
// import PendingAddRatingReview from "../PendingAddRatingReview";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const OpenIssuesUserTableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };

  return (
    <Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="m-auto" style={{ width: "99%" }}>
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody>
                <tr
                  className="super_admin_all_users_table_body super-admin-suggestion-table-body"
                  onClick={showTr}
                >
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {props?.issue?.ticket_number !== undefined &&
                      props?.issue?.ticket_number !== null
                        ? props?.issue?.ticket_number
                        : "_"}
                    </div>
                    <div className="f12-500">
                      {props?.issue?.seating_request_no !== undefined &&
                      props?.issue?.seating_request_no !== null
                        ? props?.issue?.seating_request_no
                        : "_"}
                    </div>
                  </td>
                  <td style={{ width: "18%" }}>
                    <div className="super-admin-suggestion-table-body-boxone">
                      <div className="super-admin-suggestion-imageBox mr-3">
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              fluid
                              src={props?.issue?.restaurant_id?.logo_url}
                              alt={`${props?.issue?.restaurant_id?.restaurant_name} Icon`}
                              title={`${props?.issue?.restaurant_id?.restaurant_name} Icon`}
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                      </div>
                      <div className="super-admin-suggestion-imageBoxText pl-0">
                        <div className="f14-700">
                          {props?.issue?.restaurant_id?.restaurant_name}
                        </div>
                        <div className="f11-500 text-break">
                          {props?.issue?.restaurant_id?._id}
                        </div>
                        <div className="f10-400">
                          {props?.issue?.restaurant_id?.city}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="text-center" style={{ width: "10%" }}>
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <Image
                          fluid
                          style={{ width: "35%", borderRadius: "50px" }}
                          src={
                            props?.issue?.user_id?.profile_photo[0]
                              ? props?.issue?.user_id?.profile_photo[0]
                              : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                          }
                          alt={`${props?.issue?.user_id?.first_name} Icon`}
                          title={`${
                            props?.issue?.user_id?.first_name !== undefined &&
                            props?.issue?.user_id?.first_name !== null
                              ? props?.issue?.user_id?.first_name
                              : ""
                          } Icon`}
                        />
                      </SRLWrapper>
                    </SimpleReactLightbox>
                    <div className="f12-500 mt-2">
                      {props?.issue?.user_id?.first_name}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {props?.issue?.ticket_category_id?.category_name}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      <div className="d-flex align-items-center">
                        <div className="image-box-new mr-2">
                          <Image
                            fluid
                            width="20px"
                            // src={require("../../../../assets/images/seatingImages/reservationBlack.png")}
                            src={
                              props?.issue?.ticket_sub_category_id?.title ===
                              "Waitlist"
                                ? require("../../../../assets/images/ActionImages/clock-circular-outline.svg")
                                : props?.issue?.ticket_sub_category_id
                                    ?.title === "Walk in"
                                ? require("../../../../assets/images/ActionImages/walking-img.svg")
                                : props?.issue?.ticket_sub_category_id
                                    ?.service_type === "Reservation"
                                ? require("../../../../assets/images/ActionImages/online-booking.svg")
                                : null
                            }
                          />
                        </div>
                        <div>
                          <div className="f12-500">
                            {props?.issue?.ticket_sub_category_id?.title}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "18%" }}>
                    <div className="f12-400">{props?.issue?.description}</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="d-flex align-items-center">
                      <div className="f12-400">
                        {calcStatus(props?.issue?.status)}
                      </div>
                      <i
                        className="ml-2 fa fa-angle-down"
                        aria-hidden="true"
                        onClick={() =>
                          props.onShowModal(props?.issue?.status, props?.issue?._id)
                        }
                      ></i>
                    </div>
                  </td>

                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {" "}
                      {moment(props?.issue?.createdAt).format("Do MMM, YYYY")}
                    </div>
                    <div className="f10-500">
                      {moment(props?.issue?.createdAt).format("hh : mm A")}
                    </div>
                  </td>
                  <td style={{ width: "14%" }}>
                    <div className="d-flex align-items-center">
                      <NavLink
                        to={`/openissuesviewusers/${props?.issue?._id}`}
                        className="enIconBtn mr-3"
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </NavLink>
                      <EditUserOpenIssues
                        issueDetail={props?.issue}
                        // updateLatest={updateLatest}
                      />
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <>
                    <tr
                      className="border-top sd_accordion_body"
                      style={{
                        backgroundColor: "#FFFFFF",
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                        boxShadow: "0px 3px 5px #00000029",
                      }}
                    >
                      <td style={{ width: "15%" }}>
                        <div className="font_18_b mb-4">Uploaded Photos</div>
                        {props?.issue?.refrence_images.length <= 0 ? (
                          <p className="f10-500">Image Not Available</p>
                        ) : (
                          <div className="row">
                            {props?.issue?.refrence_images.map(
                              (image, index) => {
                                return (
                                  <div className="col-5" key={index}>
                                    <SimpleReactLightbox>
                                      <SRLWrapper options={options}>
                                        <Image
                                          fluid
                                          className="img-thumbnail"
                                          style={{ height: "6vh" }}
                                          src={image}
                                          alt="Issues Icon"
                                          title="Issues Icon"
                                        />
                                      </SRLWrapper>
                                    </SimpleReactLightbox>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        )}
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="font_18_b mb-4">Uploaded Video</div>
                        {props?.issue?.refrence_videos.length <= 0 ? (
                          <p className="f10-500">Video Not Available</p>
                        ) : (
                          <div className="row">
                            {props?.issue?.refrence_videos.map(
                              (video, index) => {
                                return (
                                  <div className="col-9 mb-3" key={index}>
                                    <video
                                      width="100%"
                                      height="100%"
                                      controls
                                      src={video}
                                      type="video/mp4"
                                    />
                                  </div>
                                );
                              }
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};
